import { IMG_ORGANIZER } from './competitionBranding';

/** Pasek z logo organizatora pod nagłówkiem KPO – wspólny dla stron turnieju. */
export const OrganizerLogoBar = () => (
  <div className="w-full bg-white/60 py-2">
    <div className="mx-auto flex max-w-6xl items-center justify-center px-6">
      <img src={IMG_ORGANIZER} alt="Organizator turnieju" className="h-9 object-contain" />
    </div>
  </div>
);
